<div class="kpi white-bg border rounded-large ps-medium-x ps-medium-t ps-small-b">
  <h5 class="font-heading-5 ps-medium-b">{{ title }}</h5>
  <div class="content">
    <fcom-loader *ngIf="!value" [loaderType]="LoaderTheme.INLINE"></fcom-loader>

    <div class="flex" *ngIf="value">
      <h3 class="value">{{ value }}</h3>
      <div class="delta" *ngIf="delta">
        {{ delta | percent }}
        <fcom-icon [name]="deltaIcon"></fcom-icon>
      </div>
    </div>
  </div>
</div>
